import React from "react";
import { useNavigate } from "react-router-dom";

//
import { Button } from "react-bootstrap";

//
import ImageBox from "../../components/general/ImageBox";

//
import Stripe from "../../assets/img/stripe-logo.webp";

function Success() {
  let navigate = useNavigate();
  return (
    <div>
      <ImageBox src={Stripe} />
      <h4>Payment Successful</h4>
      <p>Your payment was successful. The plan was successfully purchased. </p>
      <Button
        size="lg"
        variant="info"
        className="w-100"
        onClick={() => navigate("/app/account")}
      >
        Back
      </Button>
    </div>
  );
}

export default Success;
